import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://22acf665ac71438280b917c2d61aa31a@o268291.ingest.sentry.io/5772476",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.005,
  environment: process.env.NODE_ENV,
  release: `${process.env.npm_package_version}+${process.env.GIT_COMMIT || 'dev'}`,
});

try {
  const url = new URL(document.referrer);
  Sentry.setTag('referrer', url.hostname);
} catch (error) {
  Sentry.setTag('referrer', 'unknown');
}
